export const SHARED_BUSINESS_FLOW_PROCESS_FLOW_B_VERIFICATION_TYPE = 'BVerification';
